import React, { FC, useEffect } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { useParams } from 'react-router-dom'
import useQuery from '../../../hooks/location/useQuery'
import useProviders from '../../../hooks/admin/useProviders'
import { buildPractitionerName, buildProviderId, buildProviderGender } from '../../../utils/fhirUtils/practitioner'
import isAuthenticated from '../../../routes/PrivateRoute/'
import FhirLoader from '../../../components/FhirLoader'
import PageTitle from '../../../components/PageTitle'

type RouteMatchParams = {
  providerId: string;
}

const Provider: FC = () => {
  const { providerId } = useParams<RouteMatchParams>()
  const query = useQuery()
  const name = query.get('name')
  const id = query.get('id')

  const { isLoading, data: providers, refetch, isFetching } = useProviders(name || '', id || '')
  useEffect(() => {
    refetch()
  }, [])
  const provider = providers && providers.find((provider: any) => provider.id === providerId)
  const providerName = provider && provider.name ? buildPractitionerName(provider.name) : ''

  return (
    <Container
      className='pt-3 pb-3'
    >
      <PageTitle
        displayName={providerName ? `Provider Profile: ${providerName}` : 'Provider Profile'}
      />
      <Row>
        <Col sm={6}>
          <h1 className="h3">
            Provider Profile: {providerName}
          </h1>
        </Col>
        <Col sm={12}>
          <section className='dataContainer'>
            {
              isLoading || isFetching ? (
                <div className='d-flex dataContainer'>
                  <FhirLoader message='Loading Provider Profile...' />
                </div>
              ) : provider && Object.keys(provider).length > 0 ? (
                <dl>
                  <Row>
                    <Col sm={3}>
                      <dt>Provider Name</dt>
                    </Col>
                    <Col sm={9}>
                      <dd>
                        {provider.name ? buildPractitionerName(provider.name) : 'N/A'}
                      </dd>
                    </Col>
                    <Col sm={3}>
                      <dt>Provider ID</dt>
                    </Col>
                    <Col sm={9}>
                      <dd>
                        {provider.id ? buildProviderId(provider) : 'N/A'}
                      </dd>
                    </Col>
                    <Col sm={3}>
                      <dt>Gender</dt>
                    </Col>
                    <Col sm={9}>
                      <dd>
                        {provider.gender ? buildProviderGender(provider) : 'N/A'}
                      </dd>
                    </Col>
                    <Col sm={3}>
                      <dt>Address</dt>
                    </Col>
                    <Col sm={9}>
                      <dd>

                      </dd>
                    </Col>

                  </Row>
                </dl>
              ) :
                <div className='text-center'>
                  No Profile found for this provider.
                </div>
            }
          </section>
        </Col>
      </Row>
    </Container>
  )
}

export default isAuthenticated(Provider)
